/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import { defaultOptions, deserify } from "@karmaniverous/serify-deserify"
import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "app/store"
import { CurrentUserParameters } from "features/userParameters/UserParametersSchemata"
import { useSelector } from "react-redux"
import { DeepReadonly } from "utils/readonly"

// Create a memoized selector outside the hook
// AIDEV-NOTE: The input selector takes only the slice it reads, deeply readonly, so the
// selector cannot mutate store state; deserify returns a fresh mutable object.
const selectLastSubmittedUserParameters = createSelector(
  (state: DeepReadonly<Pick<RootState, "lastSubmittedParameters">>) =>
    state.lastSubmittedParameters.parameters,
  (serialized: DeepReadonly<CurrentUserParameters> | null): CurrentUserParameters | null => {
    if (!serialized) {
      return null
    }
    return deserify(serialized, defaultOptions) as CurrentUserParameters
  }
)

export function useLastSubmittedUserParameters(): CurrentUserParameters | null {
  return useSelector(selectLastSubmittedUserParameters)
}
